import React, { useMemo, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {BENEFIT_TABS, familyMemberTexts, productType} from '../Conatant';
import {setCurrentStep, toggleSelectedBenefit, setMessageData, setActiveTab, SendBenefitsSmsToOrgFamilyMember} from '../OrganizationEmployeeSlice';
import BtnNextStep from '../BtnNextStep';
import { FLOW_STEPS, messageData } from '../Conatant';
import Image from 'app/Components/Shared/Image/image';
import vIcon from '../icons/v.svg';
function BenefitsSelectionStep(props) {
  const {productsDescription, familyMembers, selectedBenefits, isSettingsLoaded, orgName, notifiedMembers , className , activeTab, setActiveTab, SendBenefitsSmsToOrgFamilyMember} = props;

  const productKeys = useMemo(() => {
    const keys = Object.keys(productsDescription || {}).filter(
      (key) => productsDescription[key].quantity > 0,
    );
    return [...keys].sort((a, b) => {
      const aNoRemaining = productsDescription[a].remaining === 0 ? 1 : 0;
      const bNoRemaining = productsDescription[b].remaining === 0 ? 1 : 0;
      return aNoRemaining - bNoRemaining;
    });
  }, [productsDescription]);


 const sendBenefitsSms = async (phoneNumber) => {
  await SendBenefitsSmsToOrgFamilyMember(phoneNumber);
 }

  if (isSettingsLoaded && !productKeys.length) {
    return <div className='empty-settings'>{familyMemberTexts.emptySettings}</div>;
  }

  if (!isSettingsLoaded) {
    return null;
  }

  return (
    <>
    <div className={`${className}`}>
   
      <div className='benefits-tabs' role='tablist'>
        <button
          type='button'
          role='tab'
          className={`benefits-tab ${activeTab === BENEFIT_TABS.ALL ? 'active' : ''}`}
          aria-selected={activeTab === BENEFIT_TABS.ALL}
          onClick={() => setActiveTab(BENEFIT_TABS.ALL)}>
          {familyMemberTexts.tabs.all}
        </button>
        <button
          type='button'
          role='tab'
          className={`benefits-tab ${activeTab === BENEFIT_TABS.SENT ? 'active' : ''}`}
          aria-selected={activeTab === BENEFIT_TABS.SENT}
          onClick={() => setActiveTab(BENEFIT_TABS.SENT)}>
          {familyMemberTexts.tabs.sent}
        </button>
      </div>

      {activeTab === BENEFIT_TABS.ALL && (
          <div className='benefit-cards'>
            {productKeys.map((key) => {
              var product = productsDescription[key];
              const title =`הטבת ${product.name ? product.name : productType[key]}`;
              const description = product.description;
              const isSelected = selectedBenefits.includes(key);
              const noRemaining = product.remaining == 0;
               let used = product.quantity - product.remaining;
               let usedToDisplay = used>0 ? used : 0;
              return (
                <button
                  type='button'
                  key={key}
                  className={`benefit-card ${isSelected ? 'selected' : ''} ${noRemaining ? 'disabled' : ''}`}
                  onClick={() => props.toggleSelectedBenefit(key)}
                  aria-pressed={isSelected}
                  disabled={noRemaining}>
                  <div className='benefit-card-content'>
                    <div className='benefit-card-header'>
                      <span className={`benefit-checkbox ${isSelected ? 'checked' : ''}`} aria-hidden='true' />
                      <span className='benefit-card-title'>{title}</span>
                    </div>
                    {description && <span className='benefit-card-description'>{description}</span>}
                    <span className='benefit-card-remaining'>
                      {  `מומשו ${productsDescription[key].quantity} / ${usedToDisplay} `  }
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
      )}

      {activeTab === BENEFIT_TABS.SENT && (
        <div className='sent-benefits-list'>
          {!familyMembers.length && <div className='empty-settings'>{familyMemberTexts.sentEmpty}</div>}
          {familyMembers.map((member) => {
            const memberName = [member.firstName, member.lastName].join(' ');
            const assigned = Object.keys(member.allocations || {}).filter((key) => Number(member.allocations[key]) > 0);
            const isNotified = props.notifiedMembers.includes(member.phoneNumber);
            return (
              <div className='sent-member-card' key={member.phoneNumber}>
                <div className='sent-member-header'>
                  <span className='sent-member-name'>{memberName}</span>
                  <span className='sent-member-phone'>{member.phoneNumber}</span>
                </div>
                <div className='assigned-products'>
                  {assigned.map((key) => (
                    <span className='assigned-chip' key={`${member.phoneNumber}-${key}`}>
                      {productsDescription[key].name ? productsDescription[key].name : productType[key]} {member.allocations[key]}
                    </span>
                  ))}
                </div>
                <div className='actions'>
                  <button className={`action-button ${isNotified ? 'disabled' : ''}`} type='button' 
                  onClick={() => sendBenefitsSms(member.phoneNumber)} disabled={isNotified}>
                    {isNotified ? <Image src={vIcon} alt='notification' /> : null}

                    <span className='action-button-text'>{isNotified ? familyMemberTexts.notificationSent : familyMemberTexts.notify}</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    {activeTab === BENEFIT_TABS.ALL && (
      <BtnNextStep 
        onclick={() => selectedBenefits.length > 0}
        nextStep={FLOW_STEPS.RECIPIENT} 
        text={ selectedBenefits.length > 0 ? familyMemberTexts.continue : familyMemberTexts.chooseBenefits}
        disabled={!selectedBenefits.length}
      />
    )}
    </>
  );
}

const mapStateToProps = (state) => ({
  productsDescription: state.organizationEmployee.productsDescription,
  familyMembers: state.organizationEmployee.familyMembers,
  selectedBenefits: state.organizationEmployee.selectedBenefits,
  isSettingsLoaded: state.organizationEmployee.isSettingsLoaded,
  orgName: state.organizationEmployee.orgName,
  notifiedMembers: state.organizationEmployee.notifiedMembers,
  activeTab: state.organizationEmployee.activeTab,
});

const mapDispatchToProps = {
  toggleSelectedBenefit,
  SendBenefitsSmsToOrgFamilyMember,
  setCurrentStep,
  setMessageData,
  setActiveTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSelectionStep);
